import { render, staticRenderFns } from "./CollectionCountByStageOfUser.vue?vue&type=template&id=ca374920&scoped=true"
import script from "./CollectionCountByStageOfUser.vue?vue&type=script&lang=js"
export * from "./CollectionCountByStageOfUser.vue?vue&type=script&lang=js"
import style0 from "./CollectionCountByStageOfUser.vue?vue&type=style&index=0&id=ca374920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca374920",
  null
  
)

export default component.exports